import { ViewPublishedNotice } from './view-published-notice';

export class ViewNotice {
  noticesId: number;
  noticesTitle: string;
  noticesDescription: string;
  publishedNotices: ViewPublishedNotice[];
  createdByName: string;
  createdByNameEn: string;
  createdByImage: string;
  createdOn: string;
}
